import React, { Component } from "react"
import { Link } from "gatsby"
// import AnchorLink from 'react-anchor-link-smooth-scroll';

import Layout from "../components/layout"
import SEO from "../components/seo"

import SimpleModal from "../components/utilities/SimpleModal"

import "./casestudyautopayplus.scss"

import imgQuote from "../images/quotation_mark.webp"

export default ({ pageContext }) => (
  <Layout>
    <SEO
      title={pageContext.yoast.title}
      description={pageContext.yoast.metadesc}
      ogimg={pageContext.yoast.opengraph_image}
      link={pageContext.link}
    />
    <div className="case-study-app-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div
            className="header-container"
            style={{
              backgroundImage: `url(${pageContext.acf.header_image.csOneHedImaLocalFile.childImageSharp.fluid.src})`,
            }}
          >
            <img src={imgQuote} alt="" />
            <h2>{pageContext.acf.header_text}</h2>
          </div>
        </div>
      </div>
      <div className="container detail-wrapper">
        <div className="row">
          <div className="col-md-8">
            <img
              src={
                pageContext.acf.client_logo.csOneCliLogLocalFile.childImageSharp
                  .fluid.src
              }
              className="client-logo"
              width={pageContext.acf.client_logo.media_details.width / 1.5}
              height={pageContext.acf.client_logo.media_details.height / 1.5}
              alt={pageContext.yoast.opengraph_title}
            />
          </div>
          <div className="col-md-4">
            <a
              href="https://www.meritmile.com/uploads/2026/09/autopayplus-case-study.pdf"
              className="btn downloadBtn"
              target="_blank"
              rel="nofollow noopener noreferrer"
              style={{ marginTop: "4em" }}
            >
              Download the PDF here
            </a>
          </div>
          <div className="col-12">
            <div className="bar"></div>
          </div>
          <div className="col-12">
            <div
              className="first-paragraph"
              dangerouslySetInnerHTML={{
                __html: pageContext.acf.first_paragraph,
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 text-center">
            <img
              src="https://www.meritmile.com/uploads/2026/09/app-intro.webp"
              className="results-image img-fluid"
              alt="AutoPayPlus Intro"
              width="1400px"
              style={{
                marginTop: "2em",
                marginBottom: "6em",
                transform: "scale(1.2)",
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <h3>Challenge</h3>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12 col-md-6">
            <p>
              Managing personal finances has become increasingly difficult for consumers facing rising vehicle costs, higher interest rates, and growing household expenses. Many borrowers are unaware of strategies that can help reduce the total cost of auto loans, accelerate debt repayment, and improve long-term financial wellness. As a result, millions of consumers pay significantly more in interest over the life of their loans than necessary.
            </p>
            <p>AutoPayPlus provides an automated payment management platform that helps consumers pay down auto loans faster, reduce interest costs, and build healthier financial habits through accelerated payment programs.</p>
          </div>
          <div className="col-12 col-md-6">
            <p>
              However, despite its proven benefits, the challenge lies in increasing awareness of an often-overlooked financial strategy, educating consumers and industry stakeholders on the advantages of automated loan acceleration, and differentiating AutoPayPlus in a competitive financial services landscape.
            </p>
            <p>To address this, AutoPayPlus sought a Public Relations partner capable of elevating brand awareness, positioning its executives as trusted financial wellness experts, and communicating the tangible value its solutions provide to consumers, lenders, and automotive finance partners.</p>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6 text-center">
            <img
              src="https://www.meritmile.com/uploads/2026/09/app-strategy.webp"
              className="intro-image"
              width=""
              alt="AutoPayPlus Strategy"
              style={{ marginBottom: "0em", maxWidth: "90%" }}
            />
          </div>
          <div className="col-12 col-md-6 text-left">
            <h3>Strategy</h3>
            <p>
              Merit Mile developed an integrated Public Relations program focused on positioning AutoPayPlus as a trusted advocate for financial wellness and smarter auto loan repayment. The strategy centered on creating educational, consumer-friendly messaging that translated complex financial concepts into practical advice, demonstrating how accelerated payment strategies can help borrowers save money and achieve financial freedom sooner.
            </p>
          </div>
        </div>
        <div className="row margin-b">
            <div className="col-12">
                <p>Merit Mile developed timely story angles around consumer debt, rising interest rates, vehicle affordability, and personal finance trends, positioning AutoPayPlus executives as expert sources for media seeking insight into today's evolving lending environment. These narratives were supported through thought leadership articles, executive interviews, and proactive media outreach that highlighted both the financial impact of accelerated loan repayment and broader trends affecting consumers and the automotive finance industry.</p>
                <p>By consistently aligning AutoPayPlus with relevant economic and consumer finance conversations, Merit Mile strengthened the company's reputation as an innovative leader dedicated to helping consumers improve their financial outcomes. </p>
            </div>
        </div>
    </div>
    <div className="blue-wrapper margin-b">
        <div className="container">
            <div className="row margin-b">
                <div className="col-12">
                    <h3>Results</h3>
                    <p>
                    With the support of Merit Mile, AutoPayPlus has strengthened its visibility as a trusted voice in consumer financial wellness and automotive finance. The company has earned coverage across leading automotive, financial services, and business publications, increasing awareness of its automated payment solutions and educating consumers on the long-term benefits of accelerated loan repayment.
                    </p>
                    <p>In addition to expanding earned media visibility, AutoPayPlus executives have become recognized thought leaders on topics including consumer debt, vehicle affordability, personal finance, and financial literacy. These efforts have enhanced the company's credibility among consumers, lending partners, and industry stakeholders, reinforcing AutoPayPlus' position as an innovative financial technology company helping drivers save money, reduce debt, and take greater control of their financial future.</p>
                </div>
            </div>
            <div className="row margin-b">
                <div className="col-md-6">
                    <p style={{ fontSize: "32px", lineHeight: '1.4em', marginTop: '1.5em'}}><b>Project Totals To Date:</b> ​</p>
                    <p style={{ fontSize: "28px", lineHeight: '1.4em'}}>
                        Total impressions: <b>2,832,000</b><br />
                        Total ad equivalency: <b>$145,100</b><br />
                        Total ROI: <b>5.2X Monthly Spend</b>
                    </p>
                </div>
                <div className="col-md-6">
                    <img
                        src="https://www.meritmile.com/uploads/2026/09/app-screen.webp"
                        className="results-image img-fluid"
                        alt="AutoPayPlus Results"
                        width="800px"
                        style={{
                            marginTop: "1em",
                            marginBottom: "4em",
                        }}
                    />
                </div>
            </div>
        </div>
    </div>
    <div className="">
        <div className="row margin-b">
          <div className="col-12 text-center">
            <img
              src="https://www.meritmile.com/uploads/2026/09/app-logos.webp"
              className="results-image img-fluid"
              alt="AutoPayPlus Logos"
              width="1200px"
              style={{  marginTop: "3em", marginBottom: "3em", transform: "scale(1)", }}
            />
          </div>
        </div>
      </div>
      <div className="fullWidthGrayCTA">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h5>
                To start a conversation with Merit Mile, please drop us a line at <a href="mailto:Hello@MeritMile.com?subject=AutoPayPlus%20Case%20Study%20Inquiry">
                  <b style={{ color: "black", textDecoration: "underline" }}>Hello@MeritMile.com</b>
                </a> or call <b style={{ color: "black", textDecoration: "underline" }}>1-561-362-8888</b>. To learn more about AutoPayPlus, please visit <a href="https://autopayplus.com" target="_blank">
                  <b style={{ color: "black", textDecoration: "underline" }}>https://autopayplus.com</b></a>
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div className="fullWidthImageWrapper">
        <img
          src="https://www.meritmile.com/uploads/2021/09/mm-divider.jpg"
          alt="Merit Mile Icon Divider"
          className="img-fluid"
        />
      </div>
      <div className="about-wrapper">
        <div className="container">
          <div className="row">
            <div className="col">
              <h2>About Merit Mile</h2>
            </div>
          </div>
          <div className="row margin-b">
            <div className="col-md-6">
              <p>
                Established in 2007 in Boca Raton, FL, Merit Mile is a marketing
                services provider focused on helping companies and corporate
                marketing departments build brands, drive sales revenue, and
                garner publicity in their respective industries. Our unique
                differentiator at Merit Mile is our ability to 100% own the
                message, the publicity, and the demand generation aspects of the
                corporate marketing function. Clients hire us and rehire us for
                our ability to refine their messaging/value proposition, develop
                top and mid-funnel leads, and get the type of editorial
                publicity that differentiates them from their competitors. From
                branding to PR to demand generation, Merit Mile is the
                high-octane fuel that invigorates corporate growth engines. To
                learn more, please email us at Hello@MeritMile.com, call us at
                1-561-362-888, or visit us at www.MeritMile.com.{" "}
              </p>
            </div>
            <div className="col-md-6">
              <img
                className="img-fluid"
                src="https://www.meritmile.com/uploads/2021/06/mm-headquarter.webp"
                alt="Merit Mile Headquarter in Boca Raton, FL"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container quote-wrapper">
        <div className="row">
          <div className="col-12">
            <p>
              For more insights and to connect
              <br />
              with Merit Mile{" "}
              <a href="mailto:Hello@MeritMile.com?subject=Teldoc%20Health%20Microsoft%20Case%20Study%20Inquiry">
                <b style={{ color: "black" }}>email us here</b>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)
